import React from "react";
import plusIcon from "../Asset/plus.svg";

const AddIcon = () => {
  return (
    <div className="plus-icon-block m-1">
      <img className="plus-icon h-50" src={plusIcon} alt="" />
    </div>
  );
};
export default AddIcon;